// Этот файл генерируется автоматически, его не следует редактировать вручную
import form from '@/widgets/form.js';
import globalEventButton from '@/widgets/globalEventButton.js';
import headerScroll from '@/widgets/headerScroll.js';
import mapBlockContact from '@/widgets/mapBlockContact.js';
import popupForm from '@/widgets/popupForm.js';
import popupMenu from '@/widgets/popupMenu.js';
import scrollTop from '@/widgets/scrollTop.js';
import sliderClients from '@/widgets/sliderClients.js';
import sliderMain from '@/widgets/sliderMain.js';
import createVueWidget from '@/core/createVueWidget.js';
import sliderProducts from '@/widgets/sliderProducts.vue';
import sliderProductsGallery from '@/widgets/sliderProductsGallery.js';
import sliderProject from '@/widgets/sliderProject.js';
import subMenu from '@/widgets/subMenu.js';

export default {
  'form': async () => { return { default: form }; },
  'globalEventButton': async () => { return { default: globalEventButton }; },
  'headerScroll': async () => { return { default: headerScroll }; },
  'mapBlockContact': async () => { return { default: mapBlockContact }; },
  'popupForm': async () => { return { default: popupForm }; },
  'popupMenu': async () => { return { default: popupMenu }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'sliderClients': async () => { return { default: sliderClients }; },
  'sliderMain': async () => { return { default: sliderMain }; },
  'sliderProducts': async () => { return { default: (element, data) => createVueWidget(sliderProducts, element, data) }; },
  'sliderProductsGallery': async () => { return { default: sliderProductsGallery }; },
  'sliderProject': async () => { return { default: sliderProject }; },
  'subMenu': async () => { return { default: subMenu }; },
  'tabsSwitch': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/tabsSwitch.js'),
  'telephoneMask': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/telephoneMask.js')
};
